// extracted by mini-css-extract-plugin
export var bold = "internal-mesh-module--bold--d7b22";
export var internalMesh = "internal-mesh-module--internalMesh--ef829";
export var nextPage = "internal-mesh-module--nextPage--da35b";
export var previousPage = "internal-mesh-module--previousPage--0f655";
export var text = "internal-mesh-module--text--e62b1";
export var textContainer = "internal-mesh-module--textContainer--4daa6";